import { ref, watch, onMounted } from 'vue'

const isDark = ref(false)

function applyDarkMode(dark) {
  if (dark) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }

  localStorage.setItem('darkMode', dark ? 'true' : 'false')
}

export function useDarkMode() {
  onMounted(() => {
    const stored = localStorage.getItem('darkMode')

    if (stored !== null) {
      isDark.value = stored === 'true'
    } else {
      isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
    }

    applyDarkMode(isDark.value)
  })

  function toggleDarkMode() {
    isDark.value = !isDark.value
    applyDarkMode(isDark.value)
  }

  watch(isDark, (val) => {
    applyDarkMode(val)
  })

  return { isDark, toggleDarkMode }
}

export default useDarkMode
